import React, { useEffect, useState } from 'react';
import { G, styles, api, fmtUsd } from '../theme.js';
import { Btn, Badge, Spinner } from '../ui.jsx';

export function CoachPanel({ go = () => {}, toast = () => {} }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api('/api/growth/coach/insights').then(setData).catch(()=>{}); }, []);
  if (!data) return null;
  const sendEmail = async () => {
    setBusy(true);
    try { const r = await api('/api/growth/coach/email', { method:'POST' }); toast(r.ok?'Coach email sent':'Email failed: '+r.reason); }
    catch(e) { toast(e.message,'error'); }
    finally { setBusy(false); }
  };

  return <div style={{ ...styles.card, padding:18, marginBottom:18, borderColor: G.purple+'66' }}>
    <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:12 }}>
      <div>
        <div style={{ fontSize:11, color:G.purple, fontWeight:700, textTransform:'uppercase', letterSpacing:'.05em' }}>📊 TradeOps Coach</div>
        <h3 style={{ margin:'4px 0 0 0', fontSize:18 }}>This week at {data.business}</h3>
      </div>
      <Btn sz="sm" onClick={sendEmail} disabled={busy}>{busy?<Spinner sz={14}/>:'📧 Email me this'}</Btn>
    </div>

    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))', gap:8, marginBottom:14 }}>
      <Stat label="Jobs done" value={data.summary.completedJobs}/>
      <Stat label="Collected" value={fmtUsd(data.summary.collectedThisWeek)}/>
      <Stat label="Close rate" value={`${data.summary.closeRate}%`} c={data.summary.closeRate>=50?G.green:data.summary.closeRate>=30?G.yellow:G.red}/>
      <Stat label="New leads" value={data.summary.newLeads}/>
      {data.summary.aiBookRate > 0 && <Stat label="AI book rate" value={`${data.summary.aiBookRate}%`}/>}
    </div>

    {data.wins.length > 0 && <div style={{ marginBottom:12 }}>
      <div style={{ fontSize:12, fontWeight:700, color:G.green, marginBottom:4 }}>✅ WINS</div>
      {data.wins.map((w,i) => <div key={i} style={{ fontSize:13, padding:'2px 0' }}>• {w}</div>)}
    </div>}

    {data.insights.length > 0 && <div style={{ marginBottom:12 }}>
      <div style={{ fontSize:12, fontWeight:700, color:G.yellow, marginBottom:4 }}>⚠️ ATTENTION</div>
      {data.insights.map((i,idx) => (
        <div key={idx} style={{ ...styles.card, padding:10, marginBottom:6, borderColor: (i.severity==='high'?G.red:G.yellow)+'44' }}>
          <strong style={{ fontSize:13 }}>{i.title}</strong>
          <div style={{ fontSize:12, color:G.textMuted, marginTop:2 }}>{i.detail}</div>
          {i.action && <Btn sz="xs" v="primary" style={{ marginTop:6 }} onClick={()=>i.actionTab && go(i.actionTab)}>→ {i.action}</Btn>}
        </div>
      ))}
    </div>}

    {data.suggestions.length > 0 && <div>
      <div style={{ fontSize:12, fontWeight:700, color:G.cyan, marginBottom:4 }}>💡 ONE-CLICK ACTIONS</div>
      {data.suggestions.map((s,idx) => (
        <div key={idx} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 0', fontSize:13 }}>
          <span>{s.title}</span>
          <Badge c={G.cyan} bg={G.cyanLight}>{s.impact}</Badge>
        </div>
      ))}
    </div>}
  </div>;
}

function Stat({ label, value, c }) {
  return <div style={{ ...styles.card, padding:8, background:G.input }}>
    <div style={{ fontSize:10, color:G.textMuted, textTransform:'uppercase', letterSpacing:'.05em' }}>{label}</div>
    <div style={{ fontSize:18, fontWeight:800, color: c||G.text, marginTop:2 }}>{value}</div>
  </div>;
}
